import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Form, Dropdown } from 'react-bootstrap';
import { getRequest } from '../../helpers/apiHandler';
import config from '../../config/Constant';
import GatewayRoutesListModel from './GatewayRoutesListModel';
import RouteNameChangeModel from './GatewayRouteUpdateModel';
import ListPage from '../ListPage';

const SMSGatewayRoutes = () => {
  const { access_token } = useSelector((state) => state.auth.user);
  const [loadingData, setLoadingData] = useState(false);
  const [search, setSearch] = useState('');
  const [data, setData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [routesList, setRoutesList] = useState([]);
  const [routesModelShow, setRoutesModelShow] = useState(false);
  const [routeChangeModelShow, setRouteChangeModelShow] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});

  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const getRouteList = () => {
    const payload = {
      headers: { Authorization: access_token.token },
      params: { route_list: 'route_list' },
    };
    getRequest(`/admin/sms-gateway-routes`, payload, (res) => {
      if (res.success) {
        const result = res.data;
        setRoutesList(result);
      } else {
        setAlertState({
          message: 'There was an issue while fetching gateway routes list',
          show: true,
          variant: 'danger',
        });
      }
    });
  };

  const openModel = () => {
    setRoutesModelShow(true);
    getRouteList();
  };

  const openRouteChangeModel = (row, option) => {
    setSelectedRow({ row, option });
    setRouteChangeModelShow(true);
  };

  const getSMSGatewayRoutes = () => {
    setLoadingData(true);
    const payload = { headers: { Authorization: access_token.token } };
    getRequest(`/admin/sms-gateway-routes`, payload, (res) => {
      if (res.success) {
        const result = res.data;
        setData(result);
        setSearchData(result);
        generateColumns(result);
      } else {
        setAlertState({
          message: 'There was an issue while fetching sms gateway routes',
          show: true,
          variant: 'danger',
        });
      }
      setLoadingData(false);
    });
  };

  const sortname = (rowA, rowB) => {
    const nameA = rowA.route_name;
    const nameB = rowB.route_name;
    if (nameA > nameB) {
      return 1;
    }
    return -1;
  };

  const generateColumns = (data) => {
    if (data.length > 0) {
      const generateColumns = [
        { name: 'Name', sortable: true, selector: (row) => row.user_name },
        { name: 'Email', sortable: true, selector: (row) => row.email },
        {
          name: 'Route Name',
          sortable: true,
          sortFunction: sortname,
          selector: (row) => (
            <Form.Control
              as="select"
              style={{ fontSize: '14px' }}
              value={row.route_name}
              onChange={(e) => openRouteChangeModel(row, e.target.value)}
            >
              {row.route_options.map((option, idx) => (
                <option key={idx} value={option}>
                  {option}
                </option>
              ))}
            </Form.Control>
          ),
        },
      ];
      setColumns(generateColumns);
    }
  };

  const onSearch = (evt) => {
    const { value } = evt.target;
    const filteredData = data.filter(
      (item) =>
        item.user_name.toLowerCase().includes(value.toLowerCase()) ||
        item.email.toLowerCase().includes(value.toLowerCase())
    );

    setSearch(value);
    setSearchData(value ? filteredData : data);
  };

  useEffect(() => {
    getSMSGatewayRoutes();
  }, []);

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <ListPage
      title="Gateway Routes Management"
      search={search}
      onSearch={onSearch}
      alert={alertState}
      setAlert={setAlertState}
      columns={columns}
      data={searchData}
      loading={loadingData}
      actions={
        <>
          <Button variant="primary" onClick={() => openModel()} style={{ minWidth: 200 }}>
            Gateway Rotues List
          </Button>
        </>
      }
    >
      <GatewayRoutesListModel
        onShow={routesModelShow}
        routesList={routesList}
        setRoutesModelShow={setRoutesModelShow}
        refreshData={getRouteList}
        refreshUserRoutes={getSMSGatewayRoutes}
      />
      <RouteNameChangeModel
        onShow={routeChangeModelShow}
        data={selectedRow}
        refreshData={getSMSGatewayRoutes}
        setRouteChangeModelShow={setRouteChangeModelShow}
      />
    </ListPage>
  );
};

export default SMSGatewayRoutes;
